import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/list',
        name: 'ProductList',
        component: () => import('../views/ProductList.vue')
    },
    {
        path: '/brands',
        name: 'BrandList',
        component: () => import('../views/BrandList.vue')
    },
    {
        path: '/product/:id',
        name: 'ProductDetail',
        component: () => import('../views/ProductDetail.vue')
    },
    {
        path: '/cart',
        name: 'Cart',
        component: () => import('../views/Cart.vue')
    },
    {
        path: '/confirm-order',
        name: 'ConfirmOrder',
        component: () => import('../views/ConfirmOrder.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/order',
        name: 'OrderList',
        component: () => import('../views/OrderList.vue')
    },
    {
        path: '/address',
        name: 'AddressList',
        component: () => import('../views/AddressList.vue')
    },
    {
        path: '/checkout',
        name: 'Checkout',
        component: () => import('../views/Checkout.vue')
    },
    {
        path: '/after-sales',
        name: 'AfterSales',
        component: () => import('../views/AfterSales.vue')
    },
    {
        path: '/invoice/info',
        name: 'InvoiceInfo',
        component: () => import('../views/InvoiceInfo.vue')
    },
    {
        path: '/invoice/management',
        name: 'InvoiceManagement',
        component: () => import('../views/InvoiceManagement.vue')
    },
    {
        path: '/user',
        name: 'UserCenter',
        component: () => import('../views/UserCenter.vue')
    },
    {
        path: '/member/apply',
        name: 'MemberApply',
        component: () => import('../views/MemberApply.vue')
    },
    {
        path: '/partners',
        name: 'Partners',
        component: () => import('../views/Partners.vue')
    },
    {
        path: '/activity/huixiang',
        name: 'ActivityHuixiang',
        component: () => import('../views/ActivityHuixiang.vue')
    },
    {
        path: '/test-region',
        name: 'TestRegion',
        component: () => import('../views/TestRegion.vue')
    },
    {
        path: '/order-detail/:id',
        name: 'OrderDetail',
        component: () => import('../views/OrderDetail.vue')
    },
    {
        path: '/finder',
        name: 'FinderList',
        component: () => import('../views/FinderList.vue')
    },
    {
        path: '/category/detail',
        name: 'CategoryDetail',
        component: () => import('../views/CategoryDetail.vue')
    },
    {
        path: '/order/success',
        name: 'OrderSuccess',
        component: () => import('../views/OrderSuccess.vue')
    },
    {
        path: '/order/pay',
        name: 'OrderPay',
        component: () => import('../views/OrderPay.vue')
    },
    {
        path: '/message',
        name: 'MessageList',
        component: () => import('../views/MessageList.vue')
    },
    {
        path: '/mobile-guide',
        name: 'MobileGuide',
        component: () => import('../views/MobileGuide.vue')
    },
    {
        path: '/order/pay-success',
        name: 'PaySuccess',
        component: () => import('../views/PaySuccess.vue')
    },
    {
        path: '/help/:id',
        name: 'HelpDetail',
        component: () => import('../views/HelpDetail.vue')
    },
    {
        path: '/authentication/record',
        name: 'AuthenticationRecordList',
        component: () => import('../views/AuthenticationRecordList.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

export default router
